import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface DividerProps extends ComponentPropsWithRef<'div'> {
  /** Tekst na srodku linii — np. „LUB” miedzy logowaniem spolecznosciowym a formularzem. */
  label?: ReactNode;
}

/** Pozioma linia rozdzielajaca, opcjonalnie z etykieta. */
export function Divider({ className, label, ...props }: DividerProps) {
  if (!label) {
    return (
      <div role="separator" className={cn('border-border border-t', className)} {...props} />
    );
  }

  return (
    <div role="separator" className={cn('flex items-center gap-3', className)} {...props}>
      <span className="border-border flex-1 border-t" />
      <span className="text-fg-subtle text-[0.6875rem] font-medium tracking-[0.08em] uppercase">
        {label}
      </span>
      <span className="border-border flex-1 border-t" />
    </div>
  );
}
